var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconVideo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Iconly/Light/Video"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Video"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Stroke 1",
    d: "M26.877 24.9939L32.9853 27.4906C34.1453 27.9639 35.4153 27.1122 35.4153 25.8589V14.7939C35.4153 13.5406 34.1453 12.6872 32.9853 13.1606L26.877 15.6572",
    stroke: "white",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke 3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5063 31.9014H20.9547C24.5947 31.9014 26.878 29.5297 26.878 26.1714V14.4797C26.878 11.1214 24.6047 8.74969 20.9547 8.74969H10.5063C6.85467 8.74969 4.58301 11.1214 4.58301 14.4797V26.1714C4.58301 29.5297 6.85467 31.9014 10.5063 31.9014Z",
    stroke: "white",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconVideo);
export default __webpack_public_path__ + "static/media/icon-video.3317647535b0ffb935ca142089bc53e0.svg";
export { ForwardRef as ReactComponent };